/**
 * bootprompt.js locale configuration
 * locale : Portuguese (Brasil)
 * author : Nick Payne
 */

import { addLocale } from "../bootprompt";

addLocale("pt-br", {
  OK: "OK",
  CANCEL: "Cancelar",
  CONFIRM: "Sim",
});
